var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentcolor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.1 25.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.1 3.3L2.2.5C1.5.1.5.4.2 1.2c-.1.2-.2.4-.2.7v19.3c0 .6.3 1.1.9 1.4l5.9 2.8c.8.4 1.7 0 2.1-.7 0-.2.1-.4.1-.6V4.7c0-.6-.4-1.2-.9-1.4zm-1 12.1c-.4 0-.7-.4-.7-1s.3-1 .7-1 .7.4.7 1-.3 1-.7 1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7 2.1v7.5h1.1V2.1c0-1.1-.9-2.1-2.1-2.1H3.8L6 1.1h6.7c.5 0 1 .4 1 1zM13.7 13.5V20c0 .6-.4 1-1 1h-2.6v1.1h2.6c1.2 0 2.1-.9 2.1-2.1v-6.5h-1.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1 11.5l-3.5-2.9v2h-5.7v1.8h5.7v2.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.e142ef5c.svg";
export { ForwardRef as ReactComponent };